import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useHistory } from 'react-router-dom';
import { resetGeneralError } from 'store/actions';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { error } from 'store/selectors';


const Error: React.FC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [message, setMessage] = useState<string>('');

  const errore = useAppSelector(error);

  useEffect(() => {

    if (errore.statusCode) {
      if (errore.statusCode === 401) {
        setMessage('La sessione è scaduta. E\' necessario rieffettuare l\'accesso.');
      } else {
        setMessage(errore.message || 'Si è verificato un errore generico');
      }
      setShow(true);
    } else {
      setShow(false);
    }

  }, [errore, history]);

  const [show, setShow] = useState(false);

  const handleClose = () => {
    dispatch(resetGeneralError());
    if (errore.statusCode === 401) {
      localStorage.removeItem('accessTokenAdmin');
      localStorage.removeItem('accessTokenCliente');
      history.push(`/error-page`);
    }
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Attenzione</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>Chiudi</Button>
      </Modal.Footer>
    </Modal>
  );

}


export default Error;
